export default "__VITE_ASSET__B7rIbnH8__"